module.exports = __webpack_public_path__ + "static/media/V1_REFL.c5d84cd5.png";